var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectClinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 298,
    height: 225.836,
    viewBox: "0 0 298 225.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8505",
    "data-name": "Group 8505",
    transform: "translate(-61 -332.813)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Select_a_Clinic",
    "data-name": "Select a Clinic",
    transform: "translate(210 527.648)",
    fill: "#1b2027",
    fontSize: 16,
    fontFamily: "Rubik-Medium, Rubik",
    fontWeight: 500,
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -54,
    y: 0
  }, "Select A Clinic")), /*#__PURE__*/React.createElement("text", {
    id: "Please_select_a_clinic_to_book_an_appointment.",
    "data-name": "Please select a clinic to book an appointment.",
    transform: "translate(210 554.648)",
    fill: "#707070",
    fontSize: 14,
    fontFamily: "Rubik-Regular, Rubik",
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -148,
    y: 0
  }, "Please select a clinic to book an appointment.")), /*#__PURE__*/React.createElement("g", {
    id: "Dropdown_menu-pana",
    "data-name": "Dropdown menu-pana",
    transform: "translate(95.041 286.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-10",
    transform: "translate(41.61 195.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14811",
    "data-name": "Path 14811",
    d: "M188.308,470.761c0,.053-32.843.1-73.346.1s-73.353-.042-73.353-.1,32.836-.091,73.353-.091S188.308,470.712,188.308,470.761Z",
    transform: "translate(-41.61 -470.67)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-10",
    transform: "translate(67.562 46.22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5578",
    "data-name": "Rectangle 5578",
    width: 104.119,
    height: 149.419,
    rx: 11.55,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5579",
    "data-name": "Rectangle 5579",
    width: 97.551,
    height: 124.784,
    transform: "translate(3.087 10.661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14812",
    "data-name": "Path 14812",
    d: "M259.428,442.219a8.409,8.409,0,0,0-.172-1.056,4.284,4.284,0,0,0-5.614-2.946,4.083,4.083,0,0,0-1.074.581,3.981,3.981,0,0,0-.9.9,4.224,4.224,0,0,0,0,5.019,4.037,4.037,0,0,0,.9.9,3.984,3.984,0,0,0,1.074.581,4.277,4.277,0,0,0,2.235.19,4.2,4.2,0,0,0,1.8-.788,4.3,4.3,0,0,0,1.58-2.344,8.421,8.421,0,0,0,.172-1.056,1.52,1.52,0,0,1,0,.278,2.115,2.115,0,0,1-.025.334,3.281,3.281,0,0,1-.081.454,4.372,4.372,0,0,1-5.741,3.083,4.453,4.453,0,0,1-2.059-1.535,4.4,4.4,0,0,1,0-5.234,4.415,4.415,0,0,1,4.379-1.718,4.382,4.382,0,0,1,3.421,3.266,3.379,3.379,0,0,1,.081.454,2.11,2.11,0,0,1,.025.352,1.522,1.522,0,0,1,0,.278Z",
    transform: "translate(-203.031 -299.966)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5580",
    "data-name": "Rectangle 5580",
    width: 31.358,
    height: 1.651,
    rx: 0.825,
    transform: "translate(36.381 4.305)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5581",
    "data-name": "Rectangle 5581",
    width: 23.917,
    height: 28.933,
    transform: "translate(44.494 29.503)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14813",
    "data-name": "Path 14813",
    d: "M265.544,158.714V156.6c0-1.373,0-3.376-.021-5.917,0-5.079-.025-12.3-.042-20.9l.081.081H241.648l.067-.1V158.7l-.077-.074,17.342.039,4.85.018h.032l-4.833.021-17.391.039h-.077v-29.1h24.09v.127c0,8.62-.028,15.86-.039,20.953,0,2.531-.018,4.53-.021,5.9v1.95A.22.22,0,0,1,265.544,158.714Z",
    transform: "translate(-197.133 -100.278)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5582",
    "data-name": "Rectangle 5582",
    width: 97.551,
    height: 9.208,
    transform: "translate(3.087 10.661)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14814",
    "data-name": "Path 14814",
    d: "M137.34,87.847a1.133,1.133,0,1,1-1.13-1.2,1.162,1.162,0,0,1,1.13,1.2Z",
    transform: "translate(-128.129 -72.419)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14815",
    "data-name": "Path 14815",
    d: "M149.28,87.847a1.133,1.133,0,1,1-1.13-1.2A1.165,1.165,0,0,1,149.28,87.847Z",
    transform: "translate(-135.866 -72.419)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14816",
    "data-name": "Path 14816",
    d: "M161.22,87.847a1.133,1.133,0,1,1-1.13-1.2A1.165,1.165,0,0,1,161.22,87.847Z",
    transform: "translate(-143.603 -72.419)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5583",
    "data-name": "Rectangle 5583",
    width: 23.917,
    height: 6.681,
    rx: 2.39,
    transform: "translate(44.494 23.157)",
    fill: "#17bae0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14817",
    "data-name": "Path 14817",
    d: "M264.658,118.545a.936.936,0,0,0,.542-.225.831.831,0,0,0,.268-.641v-5.026a.8.8,0,0,0-.134-.391.824.824,0,0,0-.767-.352h-.989l-21.119.028a.753.753,0,0,0-.595.292.827.827,0,0,0-.141.31,2.365,2.365,0,0,0,0,.352v4.484a1.2,1.2,0,0,0,.1.665.753.753,0,0,0,.5.37,1.505,1.505,0,0,0,.352,0h3.808l9.5.018,6.4.032h2.193a.878.878,0,0,1,.155,0h-.609l-1.739.018-6.4.028-9.5.021H242.6a1.988,1.988,0,0,1-.373-.021.936.936,0,0,1-.623-.454.968.968,0,0,1-.113-.38v-4.759a2.234,2.234,0,0,1,0-.4.912.912,0,0,1,.176-.384.933.933,0,0,1,.739-.352l21.119.025h1.017a.94.94,0,0,1,.862.4.876.876,0,0,1,.155.447v1.274c0,1.056,0,2-.018,2.756v1a.876.876,0,0,1-.3.669.845.845,0,0,1-.412.19A.471.471,0,0,1,264.658,118.545Z",
    transform: "translate(-197.084 -88.704)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5584",
    "data-name": "Rectangle 5584",
    width: 23.917,
    height: 6.681,
    rx: 2.39,
    transform: "translate(72.279 23.157)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14818",
    "data-name": "Path 14818",
    d: "M343.61,118.545a.936.936,0,0,0,.542-.225.834.834,0,0,0,.271-.641v-5.026a.768.768,0,0,0-.134-.391.824.824,0,0,0-.767-.352H342.5l-21.119.028a.753.753,0,0,0-.595.292.827.827,0,0,0-.141.31,2.361,2.361,0,0,0,0,.352v4.484a1.2,1.2,0,0,0,.1.665.76.76,0,0,0,.5.37,1.505,1.505,0,0,0,.352,0H325.4l9.5.018,6.4.032H343.5a.878.878,0,0,1,.155,0h-.609l-1.739.018-6.4.028-9.5.021h-3.844a1.989,1.989,0,0,1-.373-.021.936.936,0,0,1-.623-.454.967.967,0,0,1-.113-.38v-4.759a2.23,2.23,0,0,1,.018-.4.954.954,0,0,1,.176-.384.933.933,0,0,1,.739-.352l21.119.025h.989a.94.94,0,0,1,.862.4.877.877,0,0,1,.155.447v1.274c0,1.056,0,2-.018,2.756v1a.876.876,0,0,1-.3.669.845.845,0,0,1-.412.19A.472.472,0,0,1,343.61,118.545Z",
    transform: "translate(-248.251 -88.704)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_330",
    "data-name": "Ellipse 330",
    cx: 8.233,
    cy: 8.233,
    r: 8.233,
    transform: "translate(9.402 34.169) rotate(-16.68)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14819",
    "data-name": "Path 14819",
    d: "M161.953,211.832c0,.049-4.878.092-10.911.092s-10.911-.042-10.911-.092,4.878-.092,10.911-.092S161.953,211.779,161.953,211.832Z",
    transform: "translate(-131.404 -153.48)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14820",
    "data-name": "Path 14820",
    d: "M161.953,227.732c0,.053-4.878.092-10.911.092s-10.911-.039-10.911-.092,4.878-.092,10.911-.092S161.953,227.682,161.953,227.732Z",
    transform: "translate(-131.404 -163.784)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14821",
    "data-name": "Path 14821",
    d: "M161.953,243.642c0,.053-4.878.092-10.911.092s-10.911-.039-10.911-.092,4.878-.092,10.911-.092S161.953,243.592,161.953,243.642Z",
    transform: "translate(-131.404 -174.094)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14822",
    "data-name": "Path 14822",
    d: "M161.953,259.552c0,.049-4.878.092-10.911.092s-10.911-.042-10.911-.092,4.878-.092,10.911-.092S161.953,259.5,161.953,259.552Z",
    transform: "translate(-131.404 -184.404)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_331",
    "data-name": "Ellipse 331",
    cx: 2.886,
    cy: 2.886,
    r: 2.886,
    transform: "translate(8.783 84.461) rotate(-22.62)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_332",
    "data-name": "Ellipse 332",
    cx: 2.886,
    cy: 2.886,
    r: 2.886,
    transform: "translate(8.781 96.574) rotate(-22.62)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_333",
    "data-name": "Ellipse 333",
    cx: 2.886,
    cy: 2.886,
    r: 2.886,
    transform: "translate(9.669 107.354)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_334",
    "data-name": "Ellipse 334",
    cx: 2.886,
    cy: 2.886,
    r: 2.886,
    transform: "translate(9.669 119.469)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14823",
    "data-name": "Path 14823",
    d: "M176.654,290.432c0,.049-2.749.091-6.135.091s-6.139-.042-6.139-.091,2.745-.092,6.139-.092S176.654,290.382,176.654,290.432Z",
    transform: "translate(-147.119 -204.415)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14824",
    "data-name": "Path 14824",
    d: "M176.654,324.832c0,.053-2.749.092-6.135.092s-6.139-.039-6.139-.092,2.745-.092,6.139-.092S176.654,324.786,176.654,324.832Z",
    transform: "translate(-147.119 -226.706)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14825",
    "data-name": "Path 14825",
    d: "M176.654,359.252c0,.053-2.749.1-6.135.1s-6.139-.042-6.139-.1,2.745-.092,6.139-.092S176.654,359.2,176.654,359.252Z",
    transform: "translate(-147.119 -249.011)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14826",
    "data-name": "Path 14826",
    d: "M176.654,393.672c0,.049-2.749.091-6.135.091s-6.139-.042-6.139-.091,2.745-.092,6.139-.092S176.654,393.619,176.654,393.672Z",
    transform: "translate(-147.119 -271.316)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14827",
    "data-name": "Path 14827",
    d: "M263.8,121.332c0,.049-2.992.092-6.688.092s-6.688-.042-6.688-.092,2.992-.092,6.688-.092S263.8,121.279,263.8,121.332Z",
    transform: "translate(-202.874 -94.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14828",
    "data-name": "Path 14828",
    d: "M295.452,120.082l.514.7a.18.18,0,0,0,.306,0l.426-.7a.187.187,0,0,0-.158-.282H295.6a.187.187,0,0,0-.151.282Z",
    transform: "translate(-232.039 -93.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14829",
    "data-name": "Path 14829",
    d: "M376.672,119.971l.51.7a.183.183,0,0,0,.31,0l.422-.7a.183.183,0,0,0-.158-.282h-.933a.187.187,0,0,0-.151.282Z",
    transform: "translate(-284.671 -93.83)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14830",
    "data-name": "Path 14830",
    d: "M266.036,146.9c0,.049-5.308.092-11.858.092s-11.858-.042-11.858-.092,5.308-.092,11.858-.092S266.036,146.849,266.036,146.9Z",
    transform: "translate(-197.626 -111.404)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14831",
    "data-name": "Path 14831",
    d: "M266.036,168.342c0,.049-5.308.092-11.858.092s-11.858-.042-11.858-.092,5.308-.092,11.858-.092S266.036,168.292,266.036,168.342Z",
    transform: "translate(-197.626 -125.298)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14832",
    "data-name": "Path 14832",
    d: "M266.036,189.832c0,.053-5.308.092-11.858.092s-11.858-.039-11.858-.092,5.308-.092,11.858-.092S266.036,189.765,266.036,189.832Z",
    transform: "translate(-197.626 -139.224)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5585",
    "data-name": "Rectangle 5585",
    width: 24.009,
    height: 7.546,
    transform: "translate(44.402 35.497)",
    fill: "#17bae0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14833",
    "data-name": "Path 14833",
    d: "M269.652,140.152c0,.049-3.643.092-8.134.092s-8.138-.042-8.138-.092,3.643-.092,8.138-.092S269.652,140.1,269.652,140.152Z",
    transform: "translate(-204.793 -107.03)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14834",
    "data-name": "Path 14834",
    d: "M267.054,158.642c0,.049-3.062.092-6.835.092s-6.839-.042-6.839-.092,3.062-.092,6.839-.092S267.054,158.592,267.054,158.642Z",
    transform: "translate(-204.793 -119.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14835",
    "data-name": "Path 14835",
    d: "M269.652,179.062c0,.053-3.643.092-8.134.092s-8.138-.039-8.138-.092,3.643-.092,8.138-.092S269.652,179.012,269.652,179.062Z",
    transform: "translate(-204.793 -132.245)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14836",
    "data-name": "Path 14836",
    d: "M269.652,200.892c0,.049-3.643.092-8.134.092s-8.138-.042-8.138-.092,3.643-.092,8.138-.092S269.652,200.839,269.652,200.892Z",
    transform: "translate(-204.793 -146.391)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14837",
    "data-name": "Path 14837",
    d: "M297.632,158.228l.7-.514a.183.183,0,0,0,0-.306l-.7-.426a.187.187,0,0,0-.282.158v.936a.187.187,0,0,0,.282.151Z",
    transform: "translate(-233.286 -117.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5586",
    "data-name": "Rectangle 5586",
    width: 23.917,
    height: 30.115,
    transform: "translate(68.432 35.497)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14838",
    "data-name": "Path 14838",
    d: "M333.551,176.936v-2.2c0-1.436,0-3.52-.021-6.17,0-5.28-.025-12.805-.042-21.738l.084.081H309.637l.092-.092v30.112l-.077-.074L327,176.89l4.847.021h.032l-4.833.021-17.395.039h-.074v-.077c0-8.6,0-18.961-.018-30.112v-.092h24.09v.084c-.018,8.954-.032,16.49-.042,21.795,0,2.636-.018,4.72-.021,6.146v2.034A.593.593,0,0,1,333.551,176.936Z",
    transform: "translate(-241.198 -111.327)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14839",
    "data-name": "Path 14839",
    d: "M334.05,189.832c0,.053-5.311.092-11.862.092s-11.858-.039-11.858-.092,5.308-.092,11.858-.092S334.05,189.765,334.05,189.832Z",
    transform: "translate(-241.697 -139.224)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14840",
    "data-name": "Path 14840",
    d: "M334.05,212.084c0,.053-5.311.092-11.862.092s-11.858-.039-11.858-.092,5.308-.084,11.851-.084S334.05,212.035,334.05,212.084Z",
    transform: "translate(-241.697 -153.649)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14841",
    "data-name": "Path 14841",
    d: "M334.05,168.342c0,.049-5.311.092-11.862.092s-11.858-.042-11.858-.092,5.308-.092,11.858-.092S334.05,168.292,334.05,168.342Z",
    transform: "translate(-241.697 -125.298)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14842",
    "data-name": "Path 14842",
    d: "M337.669,158.642c0,.049-3.643.092-8.134.092s-8.134-.042-8.134-.092,3.639-.092,8.134-.092S337.669,158.592,337.669,158.642Z",
    transform: "translate(-248.871 -119.012)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14843",
    "data-name": "Path 14843",
    d: "M337.669,179.062c0,.053-3.643.092-8.134.092s-8.134-.039-8.134-.092,3.639-.092,8.134-.092S337.669,179.012,337.669,179.062Z",
    transform: "translate(-248.871 -132.245)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5587",
    "data-name": "Rectangle 5587",
    width: 24.009,
    height: 7.846,
    transform: "translate(68.386 57.971)",
    fill: "#17bae0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14844",
    "data-name": "Path 14844",
    d: "M336.32,223.052c0,.049-3.34.092-7.462.092s-7.458-.042-7.458-.092,3.34-.092,7.458-.092S336.32,223,336.32,223.052Z",
    transform: "translate(-248.871 -160.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14845",
    "data-name": "Path 14845",
    d: "M337.669,200.892c0,.049-3.643.092-8.134.092s-8.134-.042-8.134-.092,3.639-.092,8.134-.092S337.669,200.839,337.669,200.892Z",
    transform: "translate(-248.871 -146.391)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14846",
    "data-name": "Path 14846",
    d: "M373.71,228.9l.514,4.622,1.017-.7,1.133,1.45,1.214-.869-1.049-1.33,1.109-.729Z",
    transform: "translate(-282.769 -164.6)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14847",
    "data-name": "Path 14847",
    d: "M374.5,224.082a1.9,1.9,0,0,1,.25-.778,2.188,2.188,0,0,1,.419-.7,1.9,1.9,0,0,1-.25.778C374.732,223.8,374.546,224.1,374.5,224.082Z",
    transform: "translate(-283.281 -160.518)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14848",
    "data-name": "Path 14848",
    d: "M369.439,223.033a6.336,6.336,0,0,1-.855-1.274,6.689,6.689,0,0,1-.7-1.369,13.22,13.22,0,0,1,1.549,2.643Z",
    transform: "translate(-278.991 -159.086)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14849",
    "data-name": "Path 14849",
    d: "M367.9,229.28a2.133,2.133,0,0,1-.76-.021,2.076,2.076,0,0,1-.753-.12,1.341,1.341,0,0,1,.771-.063A1.376,1.376,0,0,1,367.9,229.28Z",
    transform: "translate(-278.025 -164.695)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14850",
    "data-name": "Path 14850",
    d: "M219.772,219.3c-.053,0-.092-26.113-.092-58.32s.039-58.327.092-58.327.092,26.11.092,58.327S219.821,219.3,219.772,219.3Z",
    transform: "translate(-182.954 -82.788)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14851",
    "data-name": "Path 14851",
    d: "M292.829,289.352c0,.053-10.816.091-24.153.091s-24.156-.039-24.156-.091,10.813-.092,24.156-.092S292.829,289.3,292.829,289.352Z",
    transform: "translate(-199.051 -203.715)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14852",
    "data-name": "Path 14852",
    d: "M292.829,258.312c0,.049-10.816.091-24.153.091s-24.156-.042-24.156-.091,10.813-.092,24.156-.092S292.829,258.259,292.829,258.312Z",
    transform: "translate(-199.051 -183.6)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14853",
    "data-name": "Path 14853",
    d: "M292.829,316.651c0,.049-10.816.092-24.153.092s-24.156-.042-24.156-.092,10.813-.091,24.156-.091S292.829,316.6,292.829,316.651Z",
    transform: "translate(-199.051 -221.406)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14854",
    "data-name": "Path 14854",
    d: "M292.829,346.052c0,.053-10.816.091-24.153.091s-24.156-.039-24.156-.091,10.813-.092,24.156-.092S292.829,346,292.829,346.052Z",
    transform: "translate(-199.051 -240.457)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14855",
    "data-name": "Path 14855",
    d: "M292.829,375.461c0,.049-10.816.092-24.153.092s-24.156-.042-24.156-.092,10.813-.091,24.156-.091S292.829,375.412,292.829,375.461Z",
    transform: "translate(-199.051 -259.516)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14856",
    "data-name": "Path 14856",
    d: "M345.318,121.012c0,.049-3.231.092-7.212.092s-7.216-.042-7.216-.092,3.228-.092,7.216-.092S345.318,120.948,345.318,121.012Z",
    transform: "translate(-255.021 -94.627)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-10",
    transform: "translate(142.391 140.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14857",
    "data-name": "Path 14857",
    d: "M411.308,392.49a3.8,3.8,0,0,1,1.968-2.513,4.692,4.692,0,0,1,3.34.2,11.981,11.981,0,0,0,3.27.982,2.66,2.66,0,0,0,2.77-1.559,3,3,0,0,0-1.056-2.865,6.765,6.765,0,0,0-11.08,2.657",
    transform: "translate(-381.452 -359.954)",
    fill: "#17bae0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26562",
    "data-name": "Group 26562",
    transform: "translate(29.068 24.889)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14858",
    "data-name": "Path 14858",
    d: "M421.6,386.732a6.765,6.765,0,0,0-11.08,2.657l.8,3.1a3.8,3.8,0,0,1,1.968-2.513,4.692,4.692,0,0,1,3.34.2,11.98,11.98,0,0,0,3.27.982,2.66,2.66,0,0,0,2.77-1.559A3.034,3.034,0,0,0,421.6,386.732Z",
    transform: "translate(-410.52 -384.843)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14859",
    "data-name": "Path 14859",
    d: "M384.612,395.459c-1.672-1.591-1.591-4.361-.753-6.515a9.883,9.883,0,0,1,4.692-4.9,14.871,14.871,0,0,1,12.956-.415,6.142,6.142,0,0,0-4.97,2.921c-.919,1.521-1.123,3.372-1.88,4.981a7.849,7.849,0,0,1-10.046,3.928",
    transform: "translate(-363.798 -358.336)",
    fill: "#17bae0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14860",
    "data-name": "Path 14860",
    d: "M380.1,341.7c-1.855-2.189-2.112-5.7-1.83-8.557s.936-5.727.486-8.56c-.268-1.679-.919-3.28-1.137-4.963a5.154,5.154,0,0,1,1.408-4.678,4.515,4.515,0,0,1,5.424.218,10.226,10.226,0,0,1,3.126,4.854,20.708,20.708,0,0,1,.792,12.636c-1.193,4.122-3.991,7.8-8.1,9.049",
    transform: "translate(-360.092 -314.131)",
    fill: "#17bae0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14861",
    "data-name": "Path 14861",
    d: "M382.249,406.519a1.351,1.351,0,0,1,0-.25c0-.165,0-.412,0-.725.025-.627.084-1.535.225-2.65a34.866,34.866,0,0,1,.7-3.872,17.909,17.909,0,0,1,1.76-4.495,18.828,18.828,0,0,1,2.893-3.872,18.612,18.612,0,0,1,3.034-2.524c.465-.32.912-.563,1.3-.788s.739-.377,1.021-.514l.669-.282a2.108,2.108,0,0,1,.236-.088,1.634,1.634,0,0,1-.225.12l-.651.3c-.278.144-.62.324-1.01.539a13.32,13.32,0,0,0-1.278.8,19.084,19.084,0,0,0-5.853,6.374,23.243,23.243,0,0,0-2.51,8.314c-.155,1.112-.229,2.013-.271,2.64l-.042.722A1.72,1.72,0,0,1,382.249,406.519Z",
    transform: "translate(-363.128 -361.002)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14862",
    "data-name": "Path 14862",
    d: "M331.066,367.92c-3.428,2.07-3.418,3.953-2.844,5.73A3.594,3.594,0,0,0,332.643,376a5.389,5.389,0,0,0,2.313-2.094,9.661,9.661,0,0,1,2.038-2.4,2.613,2.613,0,0,1,2.957-.239",
    transform: "translate(-327.935 -348.987)",
    fill: "#17bae0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26563",
    "data-name": "Group 26563",
    transform: "translate(0 18.933)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14863",
    "data-name": "Path 14863",
    d: "M331.066,367.92c-3.428,2.07-3.418,3.953-2.844,5.73A3.594,3.594,0,0,0,332.643,376a5.389,5.389,0,0,0,2.313-2.094,9.661,9.661,0,0,1,2.038-2.4,2.988,2.988,0,0,1,2.077-.57Z",
    transform: "translate(-327.935 -367.92)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14864",
    "data-name": "Path 14864",
    d: "M359.57,376.47l.88.331a1.922,1.922,0,0,0-.88-.331Z",
    transform: "translate(-348.435 -354.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14865",
    "data-name": "Path 14865",
    d: "M329.54,365.816a4.055,4.055,0,0,1,4.512-.979,9.049,9.049,0,0,1,3.34,3.066,13.733,13.733,0,0,0,3.08,3.368,3.968,3.968,0,0,0,4.312.3,3.706,3.706,0,0,0,1.464-2.534,8.494,8.494,0,0,0-.2-2.992,6.443,6.443,0,0,0-1.95-3.854c-1.281-1.021-3.062-1.056-4.7-1.014a17.553,17.553,0,0,0-5.547.855,7.7,7.7,0,0,0-4.312,3.78",
    transform: "translate(-328.975 -344.613)",
    fill: "#17bae0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14866",
    "data-name": "Path 14866",
    d: "M357.927,388.066v-.3c0-.208-.018-.493-.028-.852-.021-.753-.053-1.82-.092-3.133s-.1-2.893-.19-4.639-.229-3.661-.493-5.66a18.27,18.27,0,0,0-.567-2.872A14.742,14.742,0,0,0,355.5,368.1a14.245,14.245,0,0,0-1.327-2.08,13.458,13.458,0,0,0-1.447-1.587,10.614,10.614,0,0,0-2.566-1.76c-.169-.074-.313-.151-.447-.2l-.334-.13-.2-.084c-.046-.018-.07-.028-.067-.032l.07.018.211.07.352.116c.134.049.285.12.454.194a10.3,10.3,0,0,1,2.615,1.725,13.63,13.63,0,0,1,1.475,1.591,14.587,14.587,0,0,1,1.352,2.094,15.012,15.012,0,0,1,1.056,2.534,18.076,18.076,0,0,1,.574,2.9c.268,2,.391,3.925.482,5.67s.13,3.323.158,4.646.039,2.39.042,3.129v1.074A.314.314,0,0,1,357.927,388.066Z",
    transform: "translate(-341.656 -345.294)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14867",
    "data-name": "Path 14867",
    d: "M376.554,370.375a9.7,9.7,0,0,1-.377-1.471,15.486,15.486,0,0,1-.158-4.139,27.51,27.51,0,0,1,1.309-6c.7-2.2,1.658-4.576,2.464-7.1a30.833,30.833,0,0,0,1.482-7.349,52.027,52.027,0,0,0,.109-6.132c-.06-1.76-.151-3.168-.211-4.132-.028-.482-.049-.859-.067-1.126v-.292a.353.353,0,0,1,0-.1.414.414,0,0,1,0,.1c0,.074.018.169.028.292.025.264.056.641.1,1.119.077.975.187,2.386.26,4.136a50.264,50.264,0,0,1-.077,6.149,33.349,33.349,0,0,1-.479,3.6,32.035,32.035,0,0,1-.986,3.777c-.817,2.545-1.778,4.9-2.485,7.1a27.842,27.842,0,0,0-1.334,5.984,15.841,15.841,0,0,0,.109,4.118c.084.479.158.852.229,1.1.028.12.049.215.067.285A.655.655,0,0,1,376.554,370.375Z",
    transform: "translate(-359.048 -326.054)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14868",
    "data-name": "Path 14868",
    d: "M368.6,431.588H348.245l-.465-3.918H368.6Z",
    transform: "translate(-340.795 -387.707)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14869",
    "data-name": "Path 14869",
    d: "M355.31,437.53l2.545,11.756h11.063L371.3,437.53Z",
    transform: "translate(-345.674 -394.096)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14870",
    "data-name": "Path 14870",
    d: "M370.132,438.564c0,.053-4.474.084-10,.07s-10-.074-10-.127,4.477-.084,10-.067S370.132,438.511,370.132,438.564Z",
    transform: "translate(-342.324 -394.683)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14871",
    "data-name": "Path 14871",
    d: "M372.174,452.257a8.325,8.325,0,0,0-1.8-1.028,6.358,6.358,0,0,0-2.179-.44,7.7,7.7,0,0,0-2.682.493c-.926.313-1.8.679-2.636.88a6.335,6.335,0,0,1-2.281.07,4.8,4.8,0,0,1-1.45-.465,3.021,3.021,0,0,1-.352-.225c-.077-.056-.113-.091-.109-.1s.172.1.5.25a5.076,5.076,0,0,0,1.45.4,6.4,6.4,0,0,0,2.221-.106c.817-.2,1.682-.574,2.619-.891a7.641,7.641,0,0,1,2.745-.489,6.272,6.272,0,0,1,2.228.493,5.865,5.865,0,0,1,1.327.771,3.537,3.537,0,0,1,.317.275A.515.515,0,0,1,372.174,452.257Z",
    transform: "translate(-347.864 -402.572)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14872",
    "data-name": "Path 14872",
    d: "M372.564,454.525a8.891,8.891,0,0,0-1.721-1.014,5.879,5.879,0,0,0-2.112-.436,7.553,7.553,0,0,0-2.591.468c-.9.3-1.739.648-2.545.862a6.4,6.4,0,0,1-2.189.246,3.168,3.168,0,0,1-1.781-.6q-.109-.085-.106-.1s.169.1.482.243a3.925,3.925,0,0,0,1.408.313,6.765,6.765,0,0,0,2.137-.278c.785-.222,1.623-.574,2.527-.876a7.437,7.437,0,0,1,2.657-.461,5.769,5.769,0,0,1,3.425,1.253,3.551,3.551,0,0,1,.3.268Q372.571,454.515,372.564,454.525Z",
    transform: "translate(-348.402 -404.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14873",
    "data-name": "Path 14873",
    d: "M371.98,449.776a9.762,9.762,0,0,0-1.841-1.084,6.806,6.806,0,0,0-2.235-.539,7.246,7.246,0,0,0-2.767.489,24.79,24.79,0,0,1-2.731.891,6.847,6.847,0,0,1-2.355,0,5.212,5.212,0,0,1-1.513-.479,3.141,3.141,0,0,1-.352-.225.5.5,0,0,1-.116-.1c0-.018.18.1.514.257a5.818,5.818,0,0,0,1.5.412,7.077,7.077,0,0,0,2.3-.046,27.212,27.212,0,0,0,2.7-.9,7.2,7.2,0,0,1,2.812-.465,6.666,6.666,0,0,1,2.281.588,6.494,6.494,0,0,1,1.355.82,3.286,3.286,0,0,1,.327.282.533.533,0,0,1,.116.095Z",
    transform: "translate(-347.463 -400.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14874",
    "data-name": "Path 14874",
    d: "M369.433,438.657c0,.042-4.576.077-10.186.077s-10.186-.035-10.186-.077,4.558-.077,10.186-.077S369.433,438.615,369.433,438.657Z",
    transform: "translate(-341.624 -394.776)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-10",
    transform: "translate(82.817 70.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14875",
    "data-name": "Path 14875",
    d: "M212.73,441.689l-.524,6.663s6.571,2.633,6.593,3.872l-12.928-.4.391-10.419Z",
    transform: "translate(-189.26 -326.941)",
    fill: "#17bae0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14876",
    "data-name": "Path 14876",
    d: "M212.064,459.126a.532.532,0,0,0-.394.591.51.51,0,0,0,.584.4.56.56,0,0,0,.412-.63.532.532,0,0,0-.651-.352",
    transform: "translate(-193.015 -338.42)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14877",
    "data-name": "Path 14877",
    d: "M205.87,469.471l.032-.831,12.541.655a.975.975,0,0,1,.419.662Z",
    transform: "translate(-189.26 -344.594)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14878",
    "data-name": "Path 14878",
    d: "M221.958,461.164c0,.063-.324.077-.648.271s-.5.451-.556.422.053-.391.447-.616S221.976,461.1,221.958,461.164Z",
    transform: "translate(-198.897 -339.705)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14879",
    "data-name": "Path 14879",
    d: "M226.375,463c0,.063-.268.158-.5.419s-.3.542-.352.539-.088-.352.2-.686S226.375,462.943,226.375,463Z",
    transform: "translate(-201.976 -340.92)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14880",
    "data-name": "Path 14880",
    d: "M229.879,465.822c-.056,0-.134-.31.046-.655s.482-.468.507-.412-.169.232-.31.514S229.952,465.819,229.879,465.822Z",
    transform: "translate(-204.776 -342.068)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14881",
    "data-name": "Path 14881",
    d: "M221.561,456.427c-.028.056-.317-.042-.679-.032s-.648.109-.676.053.246-.271.672-.278S221.6,456.377,221.561,456.427Z",
    transform: "translate(-198.549 -336.512)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14882",
    "data-name": "Path 14882",
    d: "M221.337,450.763a1.284,1.284,0,0,1-.655-.032,3.08,3.08,0,0,1-.676-.239,3.663,3.663,0,0,1-.352-.215.849.849,0,0,1-.19-.162.278.278,0,0,1,0-.352.352.352,0,0,1,.285-.134.941.941,0,0,1,.243.042,2.576,2.576,0,0,1,.4.158,2.235,2.235,0,0,1,.584.422c.292.292.384.535.352.546s-.169-.187-.468-.429a2.572,2.572,0,0,0-.567-.352,2.724,2.724,0,0,0-.373-.13c-.134-.042-.253-.049-.292,0s0,.032,0,.074a.7.7,0,0,0,.137.12,2.959,2.959,0,0,0,.352.211,3.484,3.484,0,0,0,.623.271A4.411,4.411,0,0,1,221.337,450.763Z",
    transform: "translate(-198.029 -332.275)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14883",
    "data-name": "Path 14883",
    d: "M166.357,441.689l-.524,6.663s6.568,2.633,6.593,3.872l-12.935-.4.391-10.419Z",
    transform: "translate(-159.205 -326.941)",
    fill: "#17bae0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14884",
    "data-name": "Path 14884",
    d: "M165.685,459.15a.539.539,0,0,0-.394.591.514.514,0,0,0,.6.412.563.563,0,0,0,.415-.63.535.535,0,0,0-.655-.352",
    transform: "translate(-162.961 -338.444)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14885",
    "data-name": "Path 14885",
    d: "M159.49,469.471l.032-.831,12.545.655a.989.989,0,0,1,.419.662Z",
    transform: "translate(-159.205 -344.594)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14886",
    "data-name": "Path 14886",
    d: "M175.58,461.164c0,.063-.324.077-.648.271s-.5.451-.56.422.053-.391.447-.616S175.594,461.1,175.58,461.164Z",
    transform: "translate(-168.839 -339.705)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14887",
    "data-name": "Path 14887",
    d: "M180.025,463c0,.063-.271.158-.5.419s-.3.542-.352.539-.088-.352.2-.686S180.025,462.943,180.025,463Z",
    transform: "translate(-171.94 -340.92)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14888",
    "data-name": "Path 14888",
    d: "M183.536,465.822c-.06,0-.134-.31.046-.655s.482-.468.507-.412-.169.232-.31.514S183.6,465.819,183.536,465.822Z",
    transform: "translate(-174.744 -342.068)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14889",
    "data-name": "Path 14889",
    d: "M175.184,456.427c-.032.056-.32-.042-.679-.032s-.648.109-.679.053.25-.271.676-.278S175.216,456.377,175.184,456.427Z",
    transform: "translate(-168.493 -336.512)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14890",
    "data-name": "Path 14890",
    d: "M174.961,450.763a1.266,1.266,0,0,1-.651-.032,3.08,3.08,0,0,1-.676-.239,3,3,0,0,1-.352-.215.859.859,0,0,1-.194-.162.285.285,0,0,1,0-.352.352.352,0,0,1,.285-.134.941.941,0,0,1,.246.042,2.538,2.538,0,0,1,.4.158,2.2,2.2,0,0,1,.588.422c.289.292.384.535.352.546s-.165-.187-.465-.429a2.6,2.6,0,0,0-.57-.352,2.677,2.677,0,0,0-.352-.13c-.137-.042-.253-.049-.292,0s0,.032,0,.074a.729.729,0,0,0,.141.12,2.957,2.957,0,0,0,.352.211,3.577,3.577,0,0,0,.619.271A4.229,4.229,0,0,1,174.961,450.763Z",
    transform: "translate(-167.978 -332.275)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14891",
    "data-name": "Path 14891",
    d: "M185.224,277.522c.609.76,12.925,29.5,12.925,32.382s-4.6,29.834-4.6,29.834l-8.448-.292s-.627-14.488.134-18.746,1.316-9.958,1.316-9.958L174.44,289.38s-1.369-8.208,0-10.64S185.224,277.522,185.224,277.522Z",
    transform: "translate(-168.498 -220.549)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14892",
    "data-name": "Path 14892",
    d: "M176.173,312.031c0,.306-4.4,12.6-5.118,16.4s-3.946,23.935-3.946,23.935l-8.419-.612s.76-21.33,2.129-27.1,2.432-10.644,2.432-13.988-1.056-3.354-.595-8.138,5.459-6.307,5.459-6.307Z",
    transform: "translate(-158.687 -232.862)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14893",
    "data-name": "Path 14893",
    d: "M191.26,336.22a2.645,2.645,0,0,0,.155.546c.109.352.289.841.524,1.447a44.186,44.186,0,0,0,2.112,4.625,43.647,43.647,0,0,0,2.64,4.347c.373.535.683.961.9,1.25a3.357,3.357,0,0,0,.352.433,2.418,2.418,0,0,0-.3-.486l-.845-1.281c-.7-1.091-1.644-2.619-2.573-4.368s-1.668-3.383-2.172-4.576c-.236-.57-.433-1.056-.591-1.408A2.877,2.877,0,0,0,191.26,336.22Z",
    transform: "translate(-179.793 -258.783)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14894",
    "data-name": "Path 14894",
    d: "M165.335,143.71a10.911,10.911,0,0,0,3.485,8.243l1.556-4.512",
    transform: "translate(-162.991 -134.033)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14895",
    "data-name": "Path 14895",
    d: "M175.33,116.918a6.635,6.635,0,0,0-4.449-.535,13.977,13.977,0,0,0-4.2,1.739,6.839,6.839,0,0,0-2.01,1.566,9.735,9.735,0,0,0-2.024,4.783,17.109,17.109,0,0,0,.94,5.558c.486,1.056,2.774,1.848,3.9,2.112L177.84,120.1a5.255,5.255,0,0,0-2.51-3.182Z",
    transform: "translate(-161.244 -116.216)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14896",
    "data-name": "Path 14896",
    d: "M199.2,122.007l-2.481-.447c1.355,3.231,1.725,10.623,2.5,14.041.915-1.327,3.041-5.371,2.925-6.98S202.151,121.732,199.2,122.007Z",
    transform: "translate(-183.331 -119.679)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14897",
    "data-name": "Path 14897",
    d: "M183.519,128.091c-.162-2.464-1.813-5.519-4.284-5.252l-5.713,1.454a4.224,4.224,0,0,0-3.192,3.9v.049l1.278,14.8,4.291,8.514h0l3.787-8.93v-2.147s3.168-.535,3.815-4.667A40.739,40.739,0,0,0,183.519,128.091Z",
    transform: "translate(-166.23 -120.498)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14898",
    "data-name": "Path 14898",
    d: "M203.056,145.782a.531.531,0,0,1-.51.539.51.51,0,0,1-.546-.479.528.528,0,0,1,.51-.535.5.5,0,0,1,.546.475Z",
    transform: "translate(-186.752 -135.066)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14899",
    "data-name": "Path 14899",
    d: "M202.107,141.372c-.067.07-.468-.225-1.038-.225s-.989.292-1.056.222.039-.155.218-.289a1.429,1.429,0,0,1,.841-.26,1.408,1.408,0,0,1,.827.264C202.107,141.235,202.153,141.341,202.107,141.372Z",
    transform: "translate(-185.452 -132.16)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14900",
    "data-name": "Path 14900",
    d: "M188.956,145.782a.532.532,0,0,1-.51.539.507.507,0,0,1-.546-.479.528.528,0,0,1,.507-.535.507.507,0,0,1,.549.475Z",
    transform: "translate(-177.615 -135.066)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14901",
    "data-name": "Path 14901",
    d: "M186.721,141.372c-.067.07-.472-.225-1.056-.222s-.986.289-1.056.218.035-.155.218-.289a1.429,1.429,0,0,1,.841-.26,1.408,1.408,0,0,1,.827.264C186.693,141.235,186.753,141.341,186.721,141.372Z",
    transform: "translate(-175.469 -132.16)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14902",
    "data-name": "Path 14902",
    d: "M195.194,146.371a3.772,3.772,0,0,1,.926-.169c.148,0,.285-.046.31-.144a.774.774,0,0,0-.1-.433l-.433-1.105a17.093,17.093,0,0,1-.975-2.9,17.133,17.133,0,0,1,1.2,2.816c.148.391.285.76.415,1.116a.834.834,0,0,1,.077.57.352.352,0,0,1-.239.215.965.965,0,0,1-.246.035A3.82,3.82,0,0,1,195.194,146.371Z",
    transform: "translate(-182.16 -132.678)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14903",
    "data-name": "Path 14903",
    d: "M181.3,168.8s1.345,2.84,5.48,2.443v-.964A10.4,10.4,0,0,1,181.3,168.8Z",
    transform: "translate(-173.338 -150.291)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14904",
    "data-name": "Path 14904",
    d: "M185.348,135.751c-.056.155-.627.081-1.3.165s-1.211.264-1.3.127c-.039-.067.053-.215.271-.352a2.193,2.193,0,0,1,.961-.352,2.151,2.151,0,0,1,1.014.116C185.246,135.561,185.369,135.677,185.348,135.751Z",
    transform: "translate(-174.275 -128.597)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14905",
    "data-name": "Path 14905",
    d: "M201.932,136.369c-.1.127-.493,0-.968,0s-.873.088-.964-.046c-.039-.067.025-.2.2-.32a1.352,1.352,0,0,1,.785-.215,1.338,1.338,0,0,1,.771.26C201.922,136.172,201.974,136.306,201.932,136.369Z",
    transform: "translate(-185.449 -128.898)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14906",
    "data-name": "Path 14906",
    d: "M180.492,121.41a1.823,1.823,0,0,0-1.605-1.031,3.562,3.562,0,0,0-1.908.556c-2.464,1.408-3.727,4.861-6.16,6.336-.6.352-1.376.032-1.887.51a1.751,1.751,0,0,0-.556,1.887,5.815,5.815,0,0,1-.845-1.429,1.964,1.964,0,0,1,.07-1.612c.211-.352.581-.641.683-1.056a4.758,4.758,0,0,0-.035-1.105,2.418,2.418,0,0,1,.377-1.056,10.718,10.718,0,0,1,3.953-4.136,6.955,6.955,0,0,1,3.625-.936,5.343,5.343,0,0,1,3.453,1.369c.546.507,1.116,1.031.834,1.721",
    transform: "translate(-164.326 -117.59)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14907",
    "data-name": "Path 14907",
    d: "M167.838,146.206a1.446,1.446,0,0,0-2.228,1.408,1.675,1.675,0,0,0,2.225,1.725C167.838,149.275,167.838,146.206,167.838,146.206Z",
    transform: "translate(-163.171 -135.508)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14908",
    "data-name": "Path 14908",
    d: "M168.182,149.8a.574.574,0,0,1-.106.056.38.38,0,0,1-.289,0,.957.957,0,0,1-.436-.866,1.271,1.271,0,0,1,.113-.553.454.454,0,0,1,.3-.3.2.2,0,0,1,.229.109c.028.063,0,.106.025.109s.049-.035.032-.127a.243.243,0,0,0-.084-.141.3.3,0,0,0-.215-.06.542.542,0,0,0-.408.352,1.306,1.306,0,0,0-.141.619,1.01,1.01,0,0,0,.556.968.412.412,0,0,0,.352-.056C168.182,149.856,168.182,149.807,168.182,149.8Z",
    transform: "translate(-164.198 -136.835)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14909",
    "data-name": "Path 14909",
    d: "M169.43,129.535a.857.857,0,0,0,.134-.074c.084-.053.215-.127.373-.236a7.789,7.789,0,0,0,1.2-1.095,20.962,20.962,0,0,0,1.471-1.911,17.676,17.676,0,0,1,1.837-2.288,6.864,6.864,0,0,1,1.186-.936,5.766,5.766,0,0,1,1.281-.581,6.371,6.371,0,0,1,2.358-.289,6.068,6.068,0,0,1,1.58.31c.183.056.317.116.412.151a.728.728,0,0,0,.144.053.673.673,0,0,0-.137-.07,3.956,3.956,0,0,0-.408-.172,5.8,5.8,0,0,0-1.587-.352,6.3,6.3,0,0,0-2.39.275,5.706,5.706,0,0,0-1.306.584,6.9,6.9,0,0,0-1.2.95,16.738,16.738,0,0,0-1.844,2.305,21.365,21.365,0,0,1-1.447,1.915,8.156,8.156,0,0,1-1.172,1.112c-.151.113-.278.19-.352.25A.8.8,0,0,0,169.43,129.535Z",
    transform: "translate(-165.646 -119.981)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14910",
    "data-name": "Path 14910",
    d: "M170.933,139.331a3.425,3.425,0,0,0,.218,1.792,1.178,1.178,0,0,0,1.517.605,1.679,1.679,0,0,0,.634-1.288c.211-1.408.306-2.855.531-4.27Z",
    transform: "translate(-166.597 -129.146)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14911",
    "data-name": "Path 14911",
    d: "M191.309,158.031a1.1,1.1,0,0,0,.549,1.721.648.648,0,0,0,.415,0,.926.926,0,0,0,.443-.574c.074-.194.151-.384.229-.577a.253.253,0,0,0,.021-.2.257.257,0,0,0-.187-.109l-1.429-.352",
    transform: "translate(-179.676 -143.254)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14912",
    "data-name": "Path 14912",
    d: "M191.974,159.508a1.246,1.246,0,0,1-.648-.081,1.017,1.017,0,0,1-.57-.461.764.764,0,0,1-.084-.443,1.2,1.2,0,0,1,.113-.458,1.1,1.1,0,0,1,.268-.37l.039-.035h.046c.947.352,1.686.5,1.679.546a5.734,5.734,0,0,1-1.732-.384h.084a1.056,1.056,0,0,0-.229.32.919.919,0,0,0-.042.753.94.94,0,0,0,.475.422C191.724,159.459,191.981,159.476,191.974,159.508Z",
    transform: "translate(-179.408 -143.072)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14913",
    "data-name": "Path 14913",
    d: "M182.365,123.889a3.756,3.756,0,0,0-.553-.049,3.847,3.847,0,0,0-1.475.268,5.117,5.117,0,0,0-.922.475,9.8,9.8,0,0,0-.95.729,11.32,11.32,0,0,0-1.865,2.01c-.282.4-.535.806-.806,1.183a5.6,5.6,0,0,1-.891,1,9.964,9.964,0,0,1-1.883,1.26c-.57.3-1.056.51-1.373.658l-.38.162a.8.8,0,0,1-.137.049.705.705,0,0,1,.127-.074l.352-.183c.32-.158.792-.38,1.352-.7a10.169,10.169,0,0,0,1.848-1.267,5.537,5.537,0,0,0,.887-.964c.268-.373.517-.781.8-1.186a11.407,11.407,0,0,1,1.89-2.024,9.385,9.385,0,0,1,.971-.725,4.837,4.837,0,0,1,.947-.472,3.7,3.7,0,0,1,1.506-.236,3.044,3.044,0,0,1,.415.056A.779.779,0,0,1,182.365,123.889Z",
    transform: "translate(-166.748 -121.128)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14914",
    "data-name": "Path 14914",
    d: "M166.295,135.962a.844.844,0,0,1-.2.13l-.563.331-.19.109a.584.584,0,0,1-.243.081.225.225,0,0,1-.151-.035.187.187,0,0,1-.081-.148.5.5,0,0,1,.1-.282l.655-1.056.088.081a2.267,2.267,0,0,1-.7.352,2.214,2.214,0,0,1-.8.1.609.609,0,0,1-.2-.035.271.271,0,0,1-.172-.148.246.246,0,0,1,.039-.225.845.845,0,0,1,.127-.141,4.7,4.7,0,0,0,.757-.957,7.278,7.278,0,0,0,.482-1.024,1.088,1.088,0,0,1-.07.3,3.929,3.929,0,0,1-.352.771,4.452,4.452,0,0,1-.753.993c-.084.081-.165.172-.134.239s.151.106.271.106a2.14,2.14,0,0,0,.753-.092,2.267,2.267,0,0,0,.679-.352l.264-.194-.176.275-.669,1.056a.4.4,0,0,0-.1.215.106.106,0,0,0,.13.1,1.158,1.158,0,0,0,.4-.162l.581-.3A.828.828,0,0,1,166.295,135.962Z",
    transform: "translate(-162.015 -127.151)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14915",
    "data-name": "Path 14915",
    d: "M251.48,165.487a7.462,7.462,0,0,1,1.408-2.981,27.673,27.673,0,0,1,3.96-3.421s3.71-1.76,4-1.524.317.641-.2.926-2.647,1.88-2.647,1.88.651.429.542.922a1.323,1.323,0,0,1-.324.683,2.077,2.077,0,0,1,.665.88,2,2,0,0,1,0,.746.584.584,0,0,1,.317.644,3.009,3.009,0,0,1-.257.915,8.4,8.4,0,0,1-2.031,1.158c-.528.056-1.225.1-1.225.1l-.556.482-.352,1.573Z",
    transform: "translate(-218.816 -142.994)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14916",
    "data-name": "Path 14916",
    d: "M158.856,193.581c.25-2.7.113-3.555.528-6.853.373-2.939,1.9-7.877,3.872-10.088l8.845,1.109a17.058,17.058,0,0,0,.535,1.651,20.185,20.185,0,0,0,1.545,3.224c1.478,2.464,3.682,5.3,4.072,6.744.042.162.451,12.861.451,12.861s1,9.525,1.918,12.766,1.9,6.128,1.76,7.184-1.76,2.049-1.76,2.049l-3-4a.979.979,0,0,0-1.566,0,14.189,14.189,0,0,0-1.83,3.228c-1.133,2.788-3.428,8.187-4.819,9.785-1.9,2.182-2.816.845-2.816.845s-6.427-8.226-7.054-11.563v.032C158.487,221.088,158.6,196.39,158.856,193.581Z",
    transform: "translate(-158.681 -155.372)",
    fill: "#17bae0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14917",
    "data-name": "Path 14917",
    d: "M202.487,178s-7.986,11.418-8.261,11.418-9.613-6.575-9.613-6.575-4.657-3.4-6.645-1.82c-3.991,3.168-.443,8.56-.443,8.56s14.009,9.535,18.324,9.887,9.873-16.874,9.873-16.874l.732-.986Z",
    transform: "translate(-169.95 -156.253)",
    fill: "#17bae0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14918",
    "data-name": "Path 14918",
    d: "M227.947,214.575a6.293,6.293,0,0,0-.282-4.245c-.06,0,.236.936.31,2.112S227.887,214.564,227.947,214.575Z",
    transform: "translate(-203.379 -177.204)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14919",
    "data-name": "Path 14919",
    d: "M229.728,213.972a3.984,3.984,0,0,0-.644-2.006,4.287,4.287,0,0,0-1.408-1.556,18.59,18.59,0,0,1,1.246,1.658A14.256,14.256,0,0,1,229.728,213.972Z",
    transform: "translate(-203.39 -177.255)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14920",
    "data-name": "Path 14920",
    d: "M179.51,174.249l-.074.669-9.926-1.929.176-2.784a.819.819,0,0,1,.936-.774c.465,0,8.5,2.017,8.8,2.225C180.217,172.172,179.51,174.249,179.51,174.249Z",
    transform: "translate(-165.698 -150.7)",
    fill: "#17bae0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14921",
    "data-name": "Path 14921",
    d: "M190.07,185.1a4.132,4.132,0,0,1,.539.32l1.429.926c1.2.788,2.858,1.887,4.671,3.122s3.435,2.386,4.576,3.245c.577.429,1.038.781,1.355,1.031a4.223,4.223,0,0,1,.479.4,5.087,5.087,0,0,1-.521-.352l-1.39-.986c-1.172-.831-2.816-1.964-4.614-3.2l-4.639-3.168-1.408-.975A4.379,4.379,0,0,1,190.07,185.1Z",
    transform: "translate(-179.022 -160.854)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14922",
    "data-name": "Path 14922",
    d: "M182.66,213.21a2.707,2.707,0,0,1,.461.253l1.228.743c1.035.63,2.464,1.5,4.058,2.432s3.059,1.76,4.122,2.323l1.26.686a2.657,2.657,0,0,1,.454.271,2.907,2.907,0,0,1-.486-.208c-.306-.144-.746-.352-1.288-.634-1.081-.549-2.555-1.345-4.153-2.281s-3.02-1.82-4.037-2.481c-.507-.327-.919-.6-1.2-.792a3.107,3.107,0,0,1-.422-.313Z",
    transform: "translate(-174.22 -179.07)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14923",
    "data-name": "Path 14923",
    d: "M174.652,191.867a1.109,1.109,0,0,1-.144-.306,4.578,4.578,0,0,1-.232-.9,5.132,5.132,0,0,1,2.531-5.255,4.481,4.481,0,0,1,.852-.384,1.057,1.057,0,0,1,.334-.077,12.041,12.041,0,0,0-1.119.574,5.28,5.28,0,0,0-2.464,5.125C174.49,191.406,174.687,191.856,174.652,191.867Z",
    transform: "translate(-168.746 -160.75)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14924",
    "data-name": "Path 14924",
    d: "M169.48,178.711a1.344,1.344,0,0,1,.37-.165,4.42,4.42,0,0,1,1.095-.2,6.621,6.621,0,0,1,1.644.123,14.248,14.248,0,0,1,1.932.549c.672.232,1.306.465,1.894.637a10.011,10.011,0,0,0,1.58.352,9.457,9.457,0,0,0,1.5.025,1.334,1.334,0,0,1-.4.088,5.278,5.278,0,0,1-1.109,0,8.912,8.912,0,0,1-1.616-.306c-.6-.165-1.235-.394-1.908-.627a15.49,15.49,0,0,0-1.908-.556,6.029,6.029,0,0,0-3.073.077Z",
    transform: "translate(-165.679 -156.471)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14925",
    "data-name": "Path 14925",
    d: "M204.359,184.1a.364.364,0,0,1-.025.106l-.084.3c-.077.268-.194.655-.352,1.158-.313,1-.792,2.446-1.447,4.206s-1.5,3.837-2.534,6.1a17.6,17.6,0,0,1-.852,1.714,3.463,3.463,0,0,1-1.44,1.408,3.168,3.168,0,0,1-2.073.148,7.979,7.979,0,0,1-1.985-.8,59.347,59.347,0,0,1-6.726-4.488c-1.992-1.478-3.8-2.816-5.4-3.777a27.2,27.2,0,0,0-3.928-2.056c-.479-.218-.873-.331-1.126-.44l-.292-.113a.554.554,0,0,1-.1-.042.352.352,0,0,1,.1.025l.3.1c.26.1.658.2,1.14.408a25.7,25.7,0,0,1,3.97,2c1.616.971,3.432,2.281,5.431,3.752a60.19,60.19,0,0,0,6.712,4.463,7.744,7.744,0,0,0,1.936.781,2.981,2.981,0,0,0,1.961-.13,3.252,3.252,0,0,0,1.362-1.334,17.714,17.714,0,0,0,.852-1.693c1.056-2.253,1.89-4.319,2.562-6.072s1.169-3.189,1.5-4.182c.162-.489.292-.873.384-1.147.042-.123.074-.222.1-.3A.422.422,0,0,1,204.359,184.1Z",
    transform: "translate(-169.904 -160.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14926",
    "data-name": "Path 14926",
    d: "M163.861,231.281a.507.507,0,0,1-.042-.063l-.12-.187c-.1-.183-.253-.443-.422-.8a18.79,18.79,0,0,1-1.056-3.221,51.342,51.342,0,0,1-1.126-11.728h0c-.151-2.724-.26-5.72-.275-8.849,0-1.76,0-3.446.046-5.09s.077-3.228.18-4.738a52.668,52.668,0,0,1,1.088-7.951,38.747,38.747,0,0,1,1.506-5.2c.225-.6.408-1.056.546-1.366.063-.148.116-.264.155-.352a.764.764,0,0,1,.056-.12.593.593,0,0,1-.039.127l-.137.352c-.127.313-.3.774-.514,1.376a41.076,41.076,0,0,0-1.447,5.2,53.832,53.832,0,0,0-1.056,7.934c-.1,1.507-.13,3.09-.169,4.734s-.053,3.34-.042,5.083c0,3.126.12,6.114.264,8.838h0a52.821,52.821,0,0,0,1.056,11.7,19.622,19.622,0,0,0,1.01,3.221c.158.352.306.623.394.81.039.088.074.155.1.211Z",
    transform: "translate(-160.067 -158.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14927",
    "data-name": "Path 14927",
    d: "M176.474,234.859a1.889,1.889,0,0,1-.042-.215c-.021-.158-.049-.352-.088-.619l-.056-.447c-.018-.165-.025-.352-.039-.535-.025-.387-.067-.824-.06-1.309v-.764c0-.264.018-.542.025-.827,0-.57.067-1.179.113-1.82.116-1.278.3-2.679.514-4.143s.433-2.855.627-4.122.313-2.415.391-3.379c.053-.482.067-.919.092-1.3s.039-.7.042-.986,0-.465.018-.627a.862.862,0,0,1,.021-.215.984.984,0,0,1,0,.215v1.616q0,.581-.063,1.309c-.06.968-.187,2.112-.352,3.39s-.387,2.664-.609,4.129-.4,2.858-.528,4.129c-.049.637-.113,1.242-.13,1.813,0,.285-.028.56-.035.824s0,.514,0,.757c0,.486.021.922.035,1.306a3.836,3.836,0,0,0,.025.535c.025.183.028.31.042.447q.032.38.053.623A.8.8,0,0,1,176.474,234.859Z",
    transform: "translate(-170.026 -179.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14928",
    "data-name": "Path 14928",
    d: "M180.434,297.024a.856.856,0,0,1-.109-.183l-.285-.542c-.127-.236-.271-.528-.419-.876s-.352-.736-.5-1.183-.352-.933-.517-1.471-.327-1.112-.489-1.721a26.417,26.417,0,0,1-.7-8.141c.056-.626.1-1.225.187-1.781s.165-1.056.26-1.535.2-.887.285-1.253.18-.679.26-.933.141-.433.187-.584a1.344,1.344,0,0,1,.077-.2.78.78,0,0,1-.042.211c-.039.155-.088.352-.151.591s-.155.57-.232.94-.187.785-.257,1.253-.176.978-.236,1.531-.12,1.147-.169,1.76a30.594,30.594,0,0,0,.049,4.072,29.986,29.986,0,0,0,.651,4.03c.155.605.292,1.186.468,1.714s.331,1.024.493,1.471.331.838.472,1.19.271.644.387.883l.253.56A1.207,1.207,0,0,1,180.434,297.024Z",
    transform: "translate(-170.78 -220.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14929",
    "data-name": "Path 14929",
    d: "M203.772,247.361a1.017,1.017,0,0,1-.021-.232c0-.169,0-.391-.025-.665,0-.6-.042-1.426-.07-2.439-.063-2.063-.172-4.907-.352-8.046s-.433-5.984-.627-8.032c-.1-1.01-.172-1.837-.229-2.432-.025-.271-.046-.493-.06-.662a1.057,1.057,0,0,1,0-.232,1.117,1.117,0,0,1,.046.229c.021.169.053.387.092.658.077.57.176,1.408.289,2.425.225,2.052.486,4.889.679,8.032s.285,5.984.313,8.057v3.108A1.505,1.505,0,0,1,203.772,247.361Z",
    transform: "translate(-187 -186.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14930",
    "data-name": "Path 14930",
    d: "M202.3,294.321a3.186,3.186,0,0,1-.419-.841,9.5,9.5,0,0,1-.57-2.207,9.349,9.349,0,0,1-.021-2.277,3.333,3.333,0,0,1,.187-.926,8.6,8.6,0,0,1-.06.936,11.615,11.615,0,0,0,.584,4.428A8.948,8.948,0,0,1,202.3,294.321Z",
    transform: "translate(-186.254 -227.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26564",
    "data-name": "Group 26564",
    transform: "translate(8.44 34.147)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14931",
    "data-name": "Path 14931",
    d: "M194.043,219.837a18.788,18.788,0,0,1-6.586-1.461c-2.239-1.007-4.347-2.735-4.8-5.146C186.651,215.374,190.048,217.679,194.043,219.837Z",
    transform: "translate(-182.66 -213.23)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14932",
    "data-name": "Path 14932",
    d: "M180.042,181.815a12.191,12.191,0,0,1-.313-1.218c-.187-.662-.429-1.172-.38-1.2a2.671,2.671,0,0,1,.556,1.147A2.714,2.714,0,0,1,180.042,181.815Z",
    transform: "translate(-172.069 -157.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26565",
    "data-name": "Group 26565",
    transform: "translate(4.076 21.932)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14933",
    "data-name": "Path 14933",
    d: "M179.883,180.488c-.106-.285-.5-.289-.806-.268a11.151,11.151,0,0,1-4.389-1.007,7.221,7.221,0,0,0-4.428-.51v.1a12.915,12.915,0,0,0,4.438,1.32,12.022,12.022,0,0,1,3.914.662,1.76,1.76,0,0,0,.8.26C179.69,181.03,179.982,180.755,179.883,180.488Z",
    transform: "translate(-170.26 -178.526)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26566",
    "data-name": "Group 26566",
    transform: "translate(24.343 33.172)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14934",
    "data-name": "Path 14934",
    d: "M229.913,212.058a3.6,3.6,0,0,0-2.017-1.6l-.056.092a6.212,6.212,0,0,1,2.024,3.956c0,.165.088.384.25.352s.18-.155.208-.275A3.615,3.615,0,0,0,229.913,212.058Z",
    transform: "translate(-227.84 -210.46)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14935",
    "data-name": "Path 14935",
    d: "M186.584,280.359a3.679,3.679,0,0,1-.475-.352c-.144-.13-.327-.278-.546-.454s-.458-.373-.736-.581c-.549-.429-1.228-.9-1.989-1.408s-1.63-1.035-2.555-1.556-1.834-.968-2.665-1.359-1.6-.7-2.256-.947c-.32-.13-.619-.232-.88-.324s-.486-.169-.672-.225a4.088,4.088,0,0,1-.57-.2,3.519,3.519,0,0,1,.591.134c.19.046.419.116.683.2s.567.176.894.3c.662.225,1.433.546,2.281.915s1.76.834,2.686,1.352,1.792,1.056,2.559,1.577,1.433,1.017,1.975,1.461c.275.215.514.422.722.605s.387.352.528.479a4.113,4.113,0,0,1,.426.391Z",
    transform: "translate(-168.115 -217.783)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26567",
    "data-name": "Group 26567",
    transform: "translate(5.203 54.202)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14936",
    "data-name": "Path 14936",
    d: "M173.652,271.189a.532.532,0,0,1,0-.813.9.9,0,0,1,.894-.092,3.2,3.2,0,0,1,.781.524c2.517,2.027,5.78,2.932,8.384,4.843a6.429,6.429,0,0,0,2.277,1.341c.3.07.669.148.736.444s-.264.531-.553.507a1.454,1.454,0,0,1-.76-.4,34.191,34.191,0,0,0-11.76-6.357",
    transform: "translate(-173.463 -270.206)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectClinic);
export default __webpack_public_path__ + "static/media/selectClinic.5429a864569b4a3c83330e0f42304cd2.svg";
export { ForwardRef as ReactComponent };